import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"
import VasionStar from "images/Vasion-Star.webp"

const TwoColumnList = ({ content }) => {
  console.log(content)
  const listItems = content?.list?.map((item, index) =>
     (
    <ListItem stars={content?.starList || content?.iconList}>
      {content.starList && <Star src={VasionStar} alt="vasion star" />}
      {content.iconList && <Icon src={content.icons[index].sourceUrl} />}
      <ListContent>
        {item.listItemHeader && (
          <ListItemHeader>{item.listItemHeader}</ListItemHeader>
        )}
        {item.listItemCopy && (
          <ListItemBody
            dangerouslySetInnerHTML={{ __html: item.listItemCopy }}
          />
        )}
      </ListContent>
    </ListItem>
  ))
  return (
    <Wrapper>
      <IntroDiv>
        {content.header && (
          <IntroHeader $headersize={content.headerSize}>
            {content.header}
          </IntroHeader>
        )}
        {content.introCopy && <IntroCopy>{content.introCopy}</IntroCopy>}
      </IntroDiv>
      <List>{listItems}</List>
    </Wrapper>
  )
}

const Icon = styled.img`
  width: 5vw;
  height: 5vw;

  ${media.fullWidth} {
    width: 72px;
    height: 72px;
  }

  ${media.tablet} {
    width: 7.031vw;
    height: 7.031vw;
  }

  ${media.mobile} {
    width: 16.822vw;
    height: 16.822vw;
  }
`
const Star = styled.img`
  width: 5vw;
  height: 5vw;

  ${media.fullWidth} {
    width: 72px;
    height: 72px;
  }

  ${media.tablet} {
    width: 7.031vw;
    height: 7.031vw;
  }

  ${media.mobile} {
    width: 16.822vw;
    height: 16.822vw;
  }
`
const ListItemBody = styled.p`
  ${text.bodySm};
`
const ListItemHeader = styled.h5`
  ${text.h5};

  ${media.mobile} {
    ${text.h4};
  }
`

const ListContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;

  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`
const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 39.167vw;
  gap: 1.389vw;

  ${media.fullWidth} {
    width: 564px;
    gap: 20px;
  }

  ${media.tablet} {
    width: 45.313vw;
    gap: 1.953vw;
  }

  ${media.mobile} {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 4.673vw;
  }
`
const List = styled.div`
  display: flex;
  flex-flow: row wrap;
  row-gap: 2.778vw;
  width: 79.444vw;

  ${media.fullWidth} {
    row-gap: 40px;
    width: 1144px;
  }

  ${media.tablet} {
    row-gap: 3.906vw;
    width: 92.188vw;
  }

  ${media.mobile} {
    flex-flow: column;
    row-gap: 9.346vw;
    width: 81.308vw;
  }
`
const IntroCopy = styled.p`
  ${text.bodySm};
`
const IntroHeader = styled.h3`
  ${props => (props.$headersize ? text.h5 : text.h3)};

  ${media.tablet} {
    ${props => (props.$headersize ? text.h3 : text.h3Mobile)};
  }

  ${media.mobile} {
    ${props => (props.$headersize ? text.h4 : text.h4)};
  }
`
const IntroDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;
  width: 79.444vw;

  ${media.fullWidth} {
    gap: 20px;
    width: 1144px;
  }

  ${media.tablet} {
    gap: 1.953vw;
    width: 92.188vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
    width: 85.28vw;
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.778vw;
  padding: 0 10.278vw;

  ${media.fullWidth} {
    gap: 40px;
    padding: 0 148px;
  }

  ${media.tablet} {
    gap: 3.906vw;
    padding: 0 14.453vw;
  }

  ${media.mobile} {
    gap: 9.346vw;
    padding: 0 9.346vw;
  }
`
export default TwoColumnList
